import { createAction } from '@reduxjs/toolkit';
export const getGoogleAuthToken = createAction('auth/getGoogleAuthToken');
